export class CoreComponetsRouting {
  static components = [
    {
      selector: 'header',
      loadChildren: () => import(/* webpackChunkName: "Core/Header" */'@cbx-ng-components/core/esm2015/lib/custom-elements/header/header.module').then(m => m.HeaderModule)
    }
  ];
}
